
































import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import basketService from '@/project/basket/basket.service';
import { BasketViewModel, LineItemViewObject, BasketQuoteViewObject } from '@/types/apiServerContract';
import CheckoutElementLayout from './CheckoutElementLayout.vue';
import OrderSummary from '@/project/ui-components/order/OrderSummary.vue';
import CheckoutOrderSummaryLineItem from './CheckoutOrderSummaryLineItem.vue';

@Component({
    components: { CheckoutElementLayout, OrderSummary, CheckoutOrderSummaryLineItem }
})
export default class CheckoutOrderSummary extends Vue {
    @Prop(Boolean)
    isErpAvailable!: boolean;

    @Prop(Boolean)
    basketUpdateInProgress!: boolean;

    get basket(): BasketViewModel | null {
        return basketService.basket;
    }

    get lineItems(): LineItemViewObject[] {
        return this.basket?.lineItems ?? [];
    }

    get quotes(): BasketQuoteViewObject[] {
        return this.basket?.quotes ?? [];
    }
}
